import React from 'react';
import '../styles/intro.css';

const Intro = () => {
    const iaawd = "https://iaawd.netlify.app/";
    const twoMinuteStory = "https://petition1.netlify.app/twominute";
    const crpd = "https://www.un.org/development/desa/disabilities/convention-on-the-rights-of-persons-with-disabilities.html";

    return (
        <div className="justified-text">
            <h4>Introduction</h4>
            <p>
                The International Association for Agricultural Workers with Disabilities (<a href={iaawd} target="_blank" rel="noopener noreferrer">IAAWD</a>) was 
                founded to advocate for the rights and interests of agricultural workers, persons with disabilities, and their families, who face systemic 
                challenges and inequities.
            </p>

            <h5>Why IAAWD Matters</h5>
            <ul>
                <li>
                    Agricultural workers and individuals with disabilities are often denied fair treatment in inheritance disputes, housing, and tax matters. 
                    For instance, after 65 years of dedicated farm work a UK family was burdened with an inequitable tax liability then subjected to years of 
                    multiple legal proceedings.
                </li>
                <li>
                    A systemic failure generating large fees & high costs for lawyers secured against farm assets without providing justice or solutions. 
                    Per this <a href={twoMinuteStory} target="_blank" rel="noopener noreferrer">2-minute story</a>.
                </li>      
            </ul>

            <h5>What Needs to Change</h5>
            <p>
                Justice requires meaningful amendments to key laws in order to reflect 
                the <a href={crpd} target="_blank" rel="noopener noreferrer">Convention on the Rights of Persons with Disabilities</a>, including:
            </p>
            <ul>
                <li><b>Housing Act 1988</b>: To better protect the housing rights of agricultural workers with disabilities and their family members.</li>
                <li><b>Senior Courts Act 1981</b>: To ensure equitable access to justice over procedural mischief.</li>
                <li><b>Protection from Eviction Act 1977</b>: To prevent wrongful evictions.</li>
            </ul>

            <h5>Join Us</h5>
            <p>
                Help us advocate for justice by supporting a petition to Parliament and working toward remedies that protect agricultural workers and persons with 
                disabilities. Together, we can build a future of fairness and dignity for all.
            </p>
        </div>
    );
};

export default Intro;
